<template>
  <button
    :type="type"
    class="pulse-btn"
    :class="[
      `pulse-btn--${severity}`,
      {
        'pulse-btn--outlined': outlined,
        'pulse-btn--text': text,
        'pulse-btn--rounded': rounded,
        'pulse-btn--small': small,
        'pulse-btn--block': block,
        'pulse-btn--icon-only': !label && !$slots.default,
      },
    ]"
    :disabled="disabled || loading"
    v-on="$listeners"
  >
    <i v-if="loading" class="pi pi-spinner pi-spin" />
    <i v-else-if="icon" :class="icon" />
    <span v-if="label || $slots.default"><slot>{{ label }}</slot></span>
  </button>
</template>

<script>
export default {
  name: "PulseButton",
  props: {
    label: { type: String, default: "" },
    icon: { type: String, default: "" },
    severity: { type: String, default: "primary" },
    type: { type: String, default: "button" },
    outlined: Boolean,
    text: Boolean,
    rounded: Boolean,
    small: Boolean,
    block: Boolean,
    loading: Boolean,
    disabled: Boolean,
  },
};
</script>
